/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import { JSONDocument, List, Translation, TranslationLanguage, TranslationSource } from "./data-contracts";

/**
 * No description
 * @tags translations
 * @name ListTranslations
 * @summary List all the translations
 * @request GET:/orgs/{organizationId}/translations
 * @secure
 */

// @ts-ignore
export const listTranslations: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Translation[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/translations",
  method: "get",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags translations
 * @name CreateTranslation
 * @summary Create a translation
 * @request POST:/orgs/{organizationId}/translations
 * @secure
 */

// @ts-ignore
export const createTranslation: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    source: TranslationSource;
    language: TranslationLanguage;
    instructions?: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: Translation;
  ResponseStatusCode: 201 | 400;
} = {
  route: "/orgs/{organizationId}/translations",
  method: "post",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags translations
 * @name GetTranslation
 * @summary Get a translation by its ID
 * @request GET:/orgs/{organizationId}/translations/{translationId}
 * @secure
 */

// @ts-ignore
export const getTranslation: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the translation */
    translationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Translation;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/translations/{translationId}",
  method: "get",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags translations
 * @name UpdateTranslation
 * @summary Update a translation
 * @request PUT:/orgs/{organizationId}/translations/{translationId}
 * @secure
 */

// @ts-ignore
export const updateTranslation: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the translation */
    translationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    instructions: JSONDocument;
  };
  RequestHeaders: {};
  ResponseBody: Translation;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/translations/{translationId}",
  method: "put",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags translations
 * @name DeleteTranslation
 * @summary Delete a translation
 * @request DELETE:/orgs/{organizationId}/translations/{translationId}
 * @secure
 */

// @ts-ignore
export const deleteTranslation: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the translation */
    translationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/translations/{translationId}",
  method: "delete",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags translations
 * @name RunTranslation
 * @summary Run a translation again
 * @request POST:/orgs/{organizationId}/translations/{translationId}/run
 * @secure
 */

// @ts-ignore
export const runTranslation: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the translation */
    translationId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 404;
} = {
  route: "/orgs/{organizationId}/translations/{translationId}/run",
  method: "post",
  streaming: false,
  tags: ["translations"],
  criticalityLevel: "low",
  deprecated: false,
};
